import React, { useState } from 'react';
import { apiPost } from '../utils/api';

const EtaCalculator = () => {
  const [distance, setDistance] = useState('');
  const [speed, setSpeed] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCalculate = async () => {
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/utils/eta', { distance, speed });
      setResult(data.eta);
    } catch (e) {
      setResult('Erro ao calcular ETA.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Calculadora de ETA</h2>
      <p className="mb-4 text-gray-600">Calcule o tempo estimado de chegada (ETA) informando distância e velocidade média.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-4">
        <input
          type="number"
          min={0}
          value={distance}
          onChange={e => setDistance(e.target.value)}
          placeholder="Distância (km)"
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <input
          type="number"
          min={0}
          value={speed}
          onChange={e => setSpeed(e.target.value)}
          placeholder="Velocidade (km/h)"
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={handleCalculate}
          disabled={loading || !distance || !speed}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50 w-full"
        >
          {loading ? 'Calculando...' : 'Calcular'}
        </button>
      </div>
      {result !== null && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-lg text-center font-mono text-gray-800">
          ETA: {result}
        </div>
      )}
    </div>
  );
};

export default EtaCalculator; 